<div class="tab-pane">
  <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
  <div class="br-none" *ngIf="screenActionList.length > 0">
    <div class="overflow-x mt-3 table-responsive box-shadow" [style.max-height.px]="myInnerHeight">
      <table class="table table-sm table-curved table-hover table-bordered">
        <thead class="box-shadow-none">
          <tr>
            <th>Screens</th>
            <th class="text-center" *ngFor="let planType of planTypeList">{{planType.itemValue}}</th>
          </tr>
        </thead>
        <tbody [style.max-height.px]="myInnerHeight">
          <ng-container *ngFor="let parentMenu of screenActionList">
            <tr class="parent-menu" *ngIf="!parentMenu.parentId">
              <td>{{parentMenu.screenName}}</td>
              <td class="text-center" *ngFor="let planType of planTypeList"></td>
            </tr>
            <ng-container *ngFor="let child of screenActionList">
              <tr *ngIf="child.parentId > 0 && child.parentId === parentMenu.id">
                <td class="pl-25">{{child.actionName}} </td>
                <td class="text-center" *ngFor="let planType of planTypeList">
                  <mat-slide-toggle [checked]="checkScreenAction(child.id, planType.itemId)"
                    (change)="updateRoleScreen(child.id, planType.itemId, $event.checked)">
                  </mat-slide-toggle>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
    <!-- <div class="card-footer" *ngIf="screenActionList.length > 0">
      <button class="btn bg-g-lightGreen btn-sm pull-right" (click)="SaveScreenAction()">Save
        <i *ngIf="isLoader" class="fa fa-circle-o-notch fa-spin" style="font-size: .875rem; line-height: 1.5;"></i>
      </button>
    </div> -->
  </div>
</div>
